<script setup lang="ts">
import { ConfidentialPage } from '@features/flatpages'
</script>

<template>
  <confidential-page />
</template>
